const CustomFieldType = {
  PARAGRAPH: "p",
  INPUT_TEXT: "text",
  INPUT_EMAIL: "email",
  TEXTAREA: "textarea",
  CHECKBOX: "checkbox",
};

export default CustomFieldType;

export const CustomFieldTypeOptions = [
  { key: CustomFieldType.PARAGRAPH, value: CustomFieldType.PARAGRAPH, translationText: "paragraph" },
  { key: CustomFieldType.INPUT_TEXT, value: CustomFieldType.INPUT_TEXT, translationText: "inputText" },
  { key: CustomFieldType.INPUT_EMAIL, value: CustomFieldType.INPUT_EMAIL, translationText: "email" },
  { key: CustomFieldType.TEXTAREA, value: CustomFieldType.TEXTAREA, translationText: "textArea" },
  { key: CustomFieldType.CHECKBOX, value: CustomFieldType.CHECKBOX, translationText: "checkbox" },
];
